import {Injectable} from "@angular/core";

@Injectable()
export class ComponentLocationStrategy {

  componentId(): string {
    return null;
  }
}
